import React from 'react';
import { X, Download } from '@phosphor-icons/react';
import { motion, AnimatePresence } from 'framer-motion';

const InstallPrompt = ({ onInstall, onDismiss }) => {
  return (
    <AnimatePresence>
      <motion.div
        initial={{ y: 100, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        exit={{ y: 100, opacity: 0 }}
        transition={{ type: 'spring', damping: 25, stiffness: 300 }}
        className="fixed bottom-20 md:bottom-4 left-4 right-4 md:left-auto md:right-4 md:max-w-sm z-[60] pb-safe"
      >
        <div className="bg-white rounded-2xl shadow-[0_10px_40px_rgba(0,0,0,0.15)] border border-gray-200 p-4">
          <div className="flex items-start gap-3">
            <div className="w-12 h-12 rounded-xl bg-gradient-to-br from-[#1B375B] to-[#659A9B] flex items-center justify-center flex-shrink-0">
              <Download size={24} weight="bold" className="text-white" />
            </div>
            
            <div className="flex-1 min-w-0">
              <h3 className="text-base font-bold text-[#1B375B] mb-1" style={{ fontFamily: 'Outfit, sans-serif' }}>
                Install ACF Tourism
              </h3>
              <p className="text-sm text-gray-600 mb-3" style={{ fontFamily: 'Manrope, sans-serif' }}>
                Get a native app experience! Install now for quick access and offline support.
              </p>
              
              <div className="flex gap-2">
                <button
                  onClick={onInstall}
                  className="flex-1 bg-[#1B375B] text-white rounded-xl px-4 py-2.5 text-sm font-semibold active:scale-95 transition-transform"
                  style={{ fontFamily: 'Manrope, sans-serif' }}
                >
                  Install
                </button>
                <button
                  onClick={onDismiss}
                  className="px-4 py-2.5 text-gray-500 text-sm font-medium active:scale-95 transition-transform"
                  style={{ fontFamily: 'Manrope, sans-serif' }}
                >
                  Not now
                </button>
              </div>
            </div>
            
            <button
              onClick={onDismiss}
              className="w-8 h-8 rounded-full hover:bg-gray-100 flex items-center justify-center flex-shrink-0 active:scale-90 transition-transform"
              aria-label="Dismiss"
            >
              <X size={18} className="text-gray-400" />
            </button>
          </div>
        </div>
      </motion.div>
    </AnimatePresence>
  );
};

export default InstallPrompt;
